import { asyncTypes } from './constants';
import type { TAsyncActionKey, TAsyncActions } from './types';

export const getAsyncActionList = <PS, PR>(actions: TAsyncActions<PS, PR>) =>
  asyncTypes.map((type: string) => actions[type.toLowerCase() as TAsyncActionKey]);
